import PublicProgramView from './view';

export default PublicProgramView;